import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { API_HOSTS, baseURL } from "apis";
import { startSurvey } from "state/modules/navigation";
import { selectQuestionnaire } from "state/modules/survey";
import * as selectors from "state/modules/survey/selectors";
import {
  retryFeedbackSubmissions,
  checkForNewDay,
} from "state/modules/feedback";

export const useMain = () => {
  const questionnaire = useSelector(selectors.getSurveyQuestionnaire);

  const dispatch = useDispatch();
  useEffect(() => {
    if (!questionnaire) {
      dispatch(selectQuestionnaire());
    }
    dispatch(retryFeedbackSubmissions());
    dispatch(checkForNewDay());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [questionnaire]);

  const qs = useSelector(selectors.getQuestionnaires);
  const areQuestionnairesAvailable = qs.reduce((t, q) => t + q.percentage, 0);

  const survey = {
    loading: areQuestionnairesAvailable && !questionnaire,
    error: !areQuestionnairesAvailable && !questionnaire,
    questionnaire,
  };

  const description = useSelector(state =>
    selectors.getSurveyDescription(state, questionnaire),
  );
  return {
    survey,
    description,
    startSurvey: () => dispatch(startSurvey()),
  };
};

export const useAppInfo = () => {
  const taker = useSelector(state => state.taker);
  const division = useSelector(state => state.division);
  const isConnected = useSelector(state => state.network.isConnected);
  return {
    taker,
    division,
    isConnected,
    getBuildEnv: () => {
      if (baseURL === API_HOSTS.PROD) {
        return "";
      }
      return " | " + BuildEnvironmentLabel[baseURL];
    },
  };
};

const BuildEnvironmentLabel = {
  [API_HOSTS.QA]: "QA",
  [API_HOSTS.PROD]: "Prod",
  [API_HOSTS.LOCAL]: "Local",
  [API_HOSTS.STAGING]: "Stage",
};
